if (!customElements.get('how-it-feels')) {
  customElements.define(
    'how-it-feels',
    class HowItFeels extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.leftImages = Array.from(
          this.querySelectorAll('.how-it-feels__left-image, .how-it-feels__image-placeholder')
        );
        this.circleImages = Array.from(
          this.querySelectorAll('.how-it-feels__circle-image, .how-it-feels__circle-placeholder')
        );
        this.panelsContainer = this.querySelector('.how-it-feels__panels');

        if (!this.tabs.length) return;

        const requested = parseInt(this.dataset.startIndex, 10);
        const start =
          Number.isNaN(requested) || requested < 0 || requested >= this.tabs.length
            ? 0
            : requested;
        this._activeIndex = start;

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('resize', this.handleResize);

        this.syncPanelHeight();
        this.activateTab(start, { moveFocus: false });

        requestAnimationFrame(() => this.syncPanelHeight());

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.syncPanelHeight());
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('resize', this.handleResize);
      }

      syncPanelHeight() {
        if (!this.panelsContainer || !this.panels.length) return;

        let maxHeight = 0;

        this.panels.forEach((panel) => {
          const wasHidden = panel.hidden;
          const previousPosition = panel.style.position;
          const previousVisibility = panel.style.visibility;
          const previousPointerEvents = panel.style.pointerEvents;
          const previousTop = panel.style.top;
          const previousLeft = panel.style.left;
          const previousWidth = panel.style.width;

          panel.hidden = false;
          panel.style.position = 'absolute';
          panel.style.visibility = 'hidden';
          panel.style.pointerEvents = 'none';
          panel.style.top = '0';
          panel.style.left = '0';
          panel.style.width = '100%';

          maxHeight = Math.max(maxHeight, panel.offsetHeight);

          panel.hidden = wasHidden;
          panel.style.position = previousPosition;
          panel.style.visibility = previousVisibility;
          panel.style.pointerEvents = previousPointerEvents;
          panel.style.top = previousTop;
          panel.style.left = previousLeft;
          panel.style.width = previousWidth;
        });

        this.style.setProperty('--hit-panel-min-height', maxHeight + 'px');
      }

      activateTab(index, { moveFocus }) {
        this._activeIndex = index;
        this.style.setProperty('--hit-active-index', index);

        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (isActive && moveFocus) tab.focus();
        });

        this.panels.forEach((panel, i) => {
          const isActive = i === index;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', false);
          if (isActive) {
            requestAnimationFrame(() => panel.classList.toggle('is-active', true));
          }
        });

        if (this.leftImages.length > 1) {
          this.leftImages.forEach((img, i) => img.classList.toggle('is-active', i === index));
        } else if (this.leftImages[0]) {
          this.leftImages[0].classList.add('is-active');
        }
        this.circleImages.forEach((img, i) => img.classList.toggle('is-active', i === index));
      }

      handleClick(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        const index = this.tabs.indexOf(tab);
        if (index === -1) return;
        this.activateTab(index, { moveFocus: false });
      }

      handleKeydown(event) {
        const currentTab = event.target.closest('[role="tab"]');
        if (!currentTab) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.activateTab(nextIndex, { moveFocus: true });
      }

      handleResize() {
        this.syncPanelHeight();
      }
    }
  );
}
